import React from "react";

export default function Footer() {
  return (
    <div className="pb-4">
      <p className="mb-6 text-sm text-gray-600 md:text-base lg:mb-0">
        ©{new Date().getFullYear()} ControlFoods. Todos os direitos reservados.
      </p>
      <p className="mb-4 text-sm text-gray-600 sm:!mb-0 md:text-base">
        Feito por WDMF Consultoria de Negocios de Implementação de Sistemas LTDA
      </p>
    </div>
  );
}
